import {
  Avatar,
  Grid,
  IconButton,
  Link,
  Tooltip,
  Typography,
} from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import CustomDataGrid from '../../../common/components/dataGrid/CustomDataGrid'
import { Add as AddIcon } from '@mui/icons-material'
import DashboardLayout from '../../../common/layouts/DashboardLayout'
import { styled } from '@mui/system'
import {
  setColumnFilters,
  setCompanyId,
  setIsOrderActivatedView,
  setResellersList,
} from '../../../store/slice/homeSlice'
import StatusChip from '../../../common/components/mui/Chips'
import { useSearchParams } from 'react-router-dom'
import { ResellersColumn } from '../../../common/components/dataGrid/columns/HomeColumns'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import {
  executeWithTryCatch,
  isResponseSuccess,
  normalizeApiResponse,
} from '../../../helpers/HelperFunctions'
import { useHomeRedux } from '../Home'
import {
  COMPANY_STATUS,
  COMPANY_STATUS_OBJ,
  TOAST_MESSAGES,
} from '../../../helpers/Constants'
import { useToastContext } from '../../../App'
import { FlexBox } from '../../../common/styles/styled-components/StyledContainers'
import { motion } from 'framer-motion'
import { useCommonRedux } from '../../../store/middlewares/CommonRedux'
import ConfirmationModal from '../../../common/components/custom/modal/modal'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { AltigenLogoFlipLoader } from '../../../common/components/loaders/loader'
import { api_DeleteResellerComany } from '../../../api/WebPortalAPI'
import { setIsLoading } from '../../../store/slice/commonSlice'
import { toggleColumnFilterValue } from '../../../common/components/dataGrid/utils/toggleColumnFilter'
import { getColumnFilterValues } from '../../../common/components/dataGrid/utils/getColumnFilterValues'
import { useGridFiltering } from '../../../common/components/dataGrid/utils/useGridFiltering'
import ColumnFilterPopover from '../../../common/components/dataGrid/columns/ColumnFilterPopover'


const FlexContainer = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'space-evenly',
  alignItems: 'center',
})

const Reseller = (props) => {
  // hooks
  const { dispatch, state } = useHomeRedux()
  const { state: commonState } = useCommonRedux()
  const { toast } = useToastContext()
  const [searchparams] = useSearchParams()
  const [selectedRow, setSelectedRow] = useState(null)
  const [isOpenDeleteConfirmation, setOpenDeleteConfirmation] = useState(false)

  const [filterAnchor, setFilterAnchor] = useState(null)
  const [activeColumn, setActiveColumn] = useState(null)
   useEffect(() => {
    dispatch(setColumnFilters({}));
  }, []);
  //lifeCycles
  useEffect(() => {
    fetchResellerList()
    // state.searchValue?.reseller && getFilteredRows()
    const OrderActivated = localStorage.getItem('OrderActivated')
    if (OrderActivated === 'true')
      dispatch(setIsOrderActivatedView(true))
  }, [state.searchValue?.reseller])

  const fetchResellerList = async () => {
    const companyId = searchparams.get('company_id')
    dispatch(setCompanyId(companyId))
  }

  const handleCopy = async (url) => {
    try {
      const permissionStatus = await navigator.permissions.query({
        name: 'clipboard-write',
      })

      if (
        permissionStatus.state === 'granted' ||
        permissionStatus.state === 'prompt'
      ) {
        await navigator.clipboard.writeText(url)
        toast.showToast('Text copied to clipboard successfully!')
      } else {
        toast.showToast('Clipboard write permission denied', 'error')
      }
    } catch (err) {
      toast.showToast('Failed to copy text: ', 'error')
    }
    navigator.clipboard.writeText(url)
  }

  const handleOpenDeleteConfirmation = (row) => {
    setOpenDeleteConfirmation(true)
    setSelectedRow(row)
  }

  const renderCompanyName = (row, value) => {
    return [COMPANY_STATUS.Active, COMPANY_STATUS.ApprovalPending].includes(
      row?.companyStatus
    ) ? (
      <FlexBox>
        <Typography variant="tablePrimary">
          <Link
            underline="none"
            color="primary"
            onClick={() => props?.onRowClick(row)}
          >
            {value}
          </Link>
          <Tooltip title="Copy Login Url">
            <IconButton onClick={() => handleCopy(row?.loginUrl)}>
              <ContentCopyIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        </Typography>

        {/* --- Delete Customer part --  */}
        <motion.div whileHover={{ scale: row.customerCount == 0 && 1.3 }}>
          {commonState.isMaster && (
            <Tooltip
              title={
                row.customerCount > 0
                  ? "Can't delete reseller with customers"
                  : 'Delete Reseller'
              }
              placement="right"
            >
              <IconButton
                color={row.customerCount > 0 ? 'default' : 'error'}
                onClick={() =>
                  row.customerCount == 0 && handleOpenDeleteConfirmation(row)
                }
                sx={{ display: 'none' }}
                disableRipple={row.customerCount > 0}
              >
                <DeleteOutlineIcon
                  color={row.customerCount > 0 ? 'default' : 'error'}
                  sx={{ fontSize: 14 }}
                />
              </IconButton>
            </Tooltip>
          )}
        </motion.div>
      </FlexBox>
    ) : (
      <FlexBox>
        <Typography variant="tablePrimary">
          {value}&nbsp;
          <Tooltip title="Copy Signup Url">
            <IconButton onClick={() => handleCopy(row?.signupUrl)}>
              <ContentCopyIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        </Typography>
        {/* --- Delete Customer part --  */}
        <motion.div whileHover={{ scale: row.customerCount == 0 && 1.3 }}>
          {commonState.isMaster && (
            <Tooltip
              title={
                row.customerCount > 0
                  ? "Can't delete reseller, Reseller has customer(s)"
                  : 'Delete Reseller'
              }
              placement="right"
            >
              <IconButton
                color={row.customerCount > 0 ? 'default' : 'error'}
                onClick={() =>
                  row.customerCount == 0 && handleOpenDeleteConfirmation(row)
                }
                sx={{ display: 'none' }}
                disableRipple={row.customerCount > 0}
              >
                <DeleteOutlineIcon
                  color={row.customerCount > 0 ? 'default' : 'error'}
                  sx={{ fontSize: 14 }}
                />
              </IconButton>
            </Tooltip>
          )}
        </motion.div>
      </FlexBox>
    )
  }

  //render company
  const renderCompany = (params) => {
    const { row, value } = params
    return (
      <FlexContainer sx={{ gap: '1rem' }}>
        <Avatar alt="logo" src={row?.logoUrl} sx={{ width: 24, height: 24 }} />
        {renderCompanyName(row, value)}
      </FlexContainer>
    )
  }

  //Render Company Status
  const renderCompanyStatus = (statusId) => {
    const status = Object.keys(COMPANY_STATUS).find(
      (key) => COMPANY_STATUS[key] === statusId
    )

    return (
      <StatusChip
        label={
          statusId === COMPANY_STATUS.ApprovalPending
            ? 'Approval Pending'
            : status
        }
        variant="outlined"
        color={COMPANY_STATUS_OBJ[statusId].color}
        isSharp
      />
    )
  }

  const handleDeleteReseller = async () => {
    setOpenDeleteConfirmation(false)
    dispatch(setIsLoading(true))
    // TODO : call delete reseller api
    executeWithTryCatch(async () => {
      const response = await api_DeleteResellerComany({
        companyId: selectedRow.id,
      })
      if (isResponseSuccess(response)) {
        const resellers = [...state.resellersList]
        const index = resellers.findIndex(
          (customer) => customer.id === selectedRow.id
        )
        if (index === -1) return
        resellers.splice(index, 1)
        dispatch(setIsLoading(false))
        setTimeout(() => dispatch(setResellersList(resellers)), 1000)
        toast.showToast(TOAST_MESSAGES.ResellerDeleted)
      }
    }, handleDeleteError)
  }

  const handleDeleteError = (error) => {
    dispatch(setIsLoading(false))
    toast.showToast(normalizeApiResponse(error)?.message, 'error')
  }
  const handleFilterClick = (event, column) => {
    event.stopPropagation()
    setFilterAnchor(event.currentTarget)
    setActiveColumn(column)
  }
  const resellerColumnProps = {
    renderCompany,
    renderCompanyStatus,
    onFilterClick: handleFilterClick,
    activeFilters: state.columnFilters,
  }

  const toggleFilterValue = (value) => {
    dispatch(
      setColumnFilters({
        ...state.columnFilters,
        [activeColumn]: toggleColumnFilterValue(
          state.columnFilters,
          activeColumn,
          value
        ),
      })
    )
  }
  const columnValues = useMemo(() => {
    return getColumnFilterValues({
      rows: state.resellersList,
      field: activeColumn,
      statusOptions: COMPANY_STATUS_OBJ,
    })
  }, [activeColumn, state.resellersList])
  const columns = useMemo(
    () => ResellersColumn(resellerColumnProps),
    [resellerColumnProps]
  )
  const filteredData = useGridFiltering({
    rows: state.resellersList,
    columns: columns,
    searchValue: state.searchValue?.reseller,
    columnFilters: state.columnFilters,
    statusField: 'companyStatus', // important
  })
  const isAnyColumnFiltered = useMemo(() => {
    return Object.values(state.columnFilters || {}).some(
      (v) => Array.isArray(v) && v.length > 0
    )
  }, [state.columnFilters])

  const activeColumnLabel = useMemo(() => {
    if (!activeColumn) return ''

    const col = ResellersColumn(resellerColumnProps).find(
      (c) => c.field === activeColumn
    )

    return col?.headerName || activeColumn
  }, [activeColumn])

  return (

    <Grid container>
      {commonState.isLoading && <AltigenLogoFlipLoader />}
      <DashboardLayout
        name="Reseller"
        buttonStartIcon={<AddIcon />}
        handleButtonClick={(e, name) => {
          props.handleShowCompany(e, name)
        }}
        children={
          <CustomDataGrid
            gridKey='reseller'
            columns={ResellersColumn(resellerColumnProps)}
            searchValue={state.searchValue?.reseller}
            noDataText="Reseller"
            data={filteredData}
            loading={!Array.isArray(state.resellersList)}
            isFiltered={isAnyColumnFiltered}
            filteredCount={filteredData.length}
            totalCount={state.resellersList.length}
          />
        }
      />
      <ConfirmationModal
        isOpen={isOpenDeleteConfirmation}
        title="Delete Reseller"
        content={
          <span>
            Are you sure you want to delete <b>{selectedRow?.name}</b> ?
          </span>
        }
        btnOk="Delete Reseller"
        btnCancel="Cancel"
        handleClose={() => setOpenDeleteConfirmation(false)}
        handleConfirm={handleDeleteReseller}
        size="sm"
      />
      {activeColumn && (
        <ColumnFilterPopover
          anchorEl={filterAnchor}
          onClose={() => {
            setFilterAnchor(null)
            setActiveColumn(null)
          }}
          title={`Filter by ${activeColumnLabel}`}
          values={columnValues}
          selectedValues={state.columnFilters[activeColumn] || []}
          onChange={toggleFilterValue}
          onClear={() =>
            dispatch(
              setColumnFilters({
                ...state.columnFilters,
                [activeColumn]: [],
              })
            )
          }
        />
      )}
    </Grid>
  )
}

export default Reseller
